import { render } from "./HuanZheView.vue?vue&type=template&id=5fc11034&scoped=true&ts=true"
import script from "./HuanZheView.vue?vue&type=script&lang=ts"
export * from "./HuanZheView.vue?vue&type=script&lang=ts"

import "./HuanZheView.vue?vue&type=style&index=0&id=5fc11034&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc11034"]])

export default __exports__